import { isAfter, isBefore, isEqual } from 'date-fns'

/**
 * Internal helper to generate an ISO date at a specific time of day in UTC.
 * @param date
 * @param hours
 * @param minutes
 * @param seconds
 * @param ms
 */
const toIsoAtUtcTime = (
	date: Date | null,
	hours = 0,
	minutes = 0,
	seconds = 0,
	ms = 0
): string | null => {
	if (!date || isNaN(date.getTime())) {
		return null
	}

	const utc = new Date(Date.UTC(
		date.getFullYear(),
		date.getMonth(),
		date.getDate(),
		hours,
		minutes,
		seconds,
		ms
	))

	return utc.toISOString()
}

/**
 * Set date at noon (12:00:00.000 UTC)
 * @param date Date
 */
export const toNoonIso = (date: Date | null): string | null => toIsoAtUtcTime(date, 12)

/**
 * Is before or equal
 * @param date
 * @param dateToCompare
 */
export const isBeforeOrEqual = (date: Date, dateToCompare: Date): boolean => isBefore(date, dateToCompare) || isEqual(date, dateToCompare)

/**
 * Is after or equal
 * @param date
 * @param dateToCompare
 */
export const isAfterOrEqual = (date: Date, dateToCompare: Date): boolean => isAfter(date, dateToCompare) || isEqual(date, dateToCompare)
